/**
 * Enum representing all available service categories in the barbershop platform
 * Used for categorizing and filtering services offered by shops and individuals
 * @constant {object}
 * @property {string} HAIRCUT - Professional hair cutting and styling services
 * @property {string} COLORING - Hair coloring, highlights, and dyeing services
 * @property {string} WASH - Hair washing and shampooing services
 * @property {string} SHAVE - Traditional and modern shaving services
 * @property {string} BEARD_TRIM - Beard grooming and trimming services
 * @property {string} TREATMENT - Hair treatment services including conditioning and repair
 * @property {string} FACIAL - Facial cleansing and skincare treatments
 * @property {string} MAKEUP - Professional makeup application services
 * @property {string} MASSAGE - Relaxation and therapeutic massage services
 * @property {string} WAXING - Hair removal and waxing services
 * @property {string} MANICURE - Hand and nail care services
 * @property {string} PEDICURE - Foot and toenail care services
 * @property {string} NAILS - General nail services including extensions and art
 * @property {string} SKINCARE - Professional skincare and beauty treatments
 * @property {string} TATTOO - Tattoo artistry and body modification services
 * @property {string} TAN - Tanning and bronzing services
 * @property {string} OTHER - Miscellaneous services not covered by other categories
 * @example
 * // Filter services by category
 * const haircutServices = services.filter(s => s.category === SERVICE_CATEGORIES.HAIRCUT);
 *
 * // Create service with category
 * const newService = {
 *   name: 'Classic Haircut',
 *   category: SERVICE_CATEGORIES.HAIRCUT,
 *   price: 25.00
 * };
 */
export const SERVICE_CATEGORIES = {
  /** Haircut services */
  HAIRCUT: 'HAIRCUT',
  /** Hair styling services */
  COLORING: 'COLORING',
  /** Hair washing services */
  WASH: 'WASH',
  /** Shaving services */
  SHAVE: 'SHAVE',
  /** Beard trimming services */
  BEARD_TRIM: 'BEARD_TRIM',
  /** Hair treatment services */
  TREATMENT: 'TREATMENT',
  /** Facial services */
  FACIAL: 'FACIAL',
  /** Makeup services */
  MAKEUP: 'MAKEUP',
  /**  Massage services */
  MASSAGE: 'MASSAGE',
  /** Waxing services */
  WAXING: 'WAXING',
  /** Manicure services */
  MANICURE: 'MANICURE',
  /** Pedicure services */
  PEDICURE: 'PEDICURE',
  /* Nail Enhancements services  */
  NAIL_ENHANCEMENTS: 'NAIL_ENHANCEMENTS',
  /* Nail Art services */
  NAIL_ART: 'NAIL_ART',
  /* Nail Rapair services */
  NAIL_REPAIR: 'NAIL_REPAIR',
  /** Nail services */
  NAILS: 'NAILS',
  /** Skincare services */
  SKINCARE: 'SKINCARE',
  /** Tattoo services */
  TATTOO: 'TATTOO',
  /** Tanning services */
  TAN: 'TAN',
  /**Shaping & Maintenance */
  SHAPING_MAINTENANCE: 'SHAPING_MAINTENANCE',
  /** Other services */
  OTHER: 'OTHER',
};

export const SERVICE_CATEGORIES_LIST = Object.values(SERVICE_CATEGORIES) as ServiceCategory[];

/**
 * Type representing valid service category keys
 * @typedef {keyof typeof SERVICE_CATEGORIES} ServiceCategory
 */
export type ServiceCategory = keyof typeof SERVICE_CATEGORIES;
